import { useEffect, useState } from "react";

// Fullscreen as a CSS overlay (fixed inset-0) — deliberately NOT the native
// Fullscreen API: modals portal to <body> and would disappear under a native
// fullscreen element. The overlay sits below Modal's z-50, so dialogs stay visible.
export function useFullscreenOverlay() {
  const [isFull, setIsFull] = useState(false);
  useEffect(() => {
    if (!isFull) return;
    const h = (e: KeyboardEvent) => {
      // let ESC close an open modal first instead of the fullscreen overlay
      if (e.key === "Escape" && !document.querySelector("[data-modal-layer]")) setIsFull(false);
    };
    document.addEventListener("keydown", h);
    return () => document.removeEventListener("keydown", h);
  }, [isFull]);
  return { isFull, toggle: () => setIsFull((v) => !v) };
}
